import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { Botijao } from "../types/Botijao";

export async function getBotijoes(search?: string, page = 1) {
  const { data } = await api.get<Paginate<Botijao>>(
    `${URLS.BOTIJAO_API}`, {
      params: {page, search}
    });

  return data;
}

export async function getBotijaoModulo(BotijaoId: number) {
  const resultJson = await api
    .get(`${URLS.BOTIJAO_API}/${BotijaoId}`)
    .then((resp) => resp.data);
  
  return resultJson;
}
